export default "__VITE_ASSET__Dnjhxdqf__"